<template>
  <div>
    <div class="d-flex align-center mb-4">
      <v-icon color="primary" size="22" class="mr-2">info</v-icon>
      <span class="subtitle-1 font-weight-bold grey--text text--darken-3">
        Recomendaciones para la importación
      </span>
    </div>

    <v-divider class="mb-6"></v-divider>

    <v-row justify="space-around">
      <v-col cols="12" md="3" class="text-center px-4">
        <v-sheet
          color="blue lighten-5"
          width="48"
          height="48"
          class="d-flex align-center justify-center rounded-lg mb-3 mx-auto"
        >
          <v-icon color="blue darken-3">menu</v-icon>
        </v-sheet>
        <h3 class="body-1 font-weight-bold mb-2 grey--text text--darken-3">
          Estructura intacta
        </h3>
        <p
          class="caption grey--text text--darken-1 text-justify px-2 lh-relaxed"
        >
          No modificar la estructura de las columnas ni los encabezados del
          archivo. No se deben diligenciar filas intermedias vacías.
        </p>
      </v-col>

      <v-col cols="12" md="3" class="text-center px-4">
        <v-sheet
          color="blue lighten-5"
          width="48"
          height="48"
          class="d-flex align-center justify-center rounded-lg mb-3 mx-auto"
        >
          <v-icon color="blue darken-3">checklist</v-icon>
        </v-sheet>
        <h3 class="body-1 font-weight-bold mb-2 grey--text text--darken-3">
          Validación de formatos
        </h3>
        <p
          class="caption grey--text text--darken-1 text-justify px-2 lh-relaxed"
        >
          Validar formatos de fecha, tipos de datos, longitud de caracteres y
          valores permitidos que se indican en la hoja de instrucciones antes de
          realizar la carga.
        </p>
      </v-col>

      <v-col cols="12" md="3" class="text-center px-4">
        <v-sheet
          color="blue lighten-5"
          width="48"
          height="48"
          class="d-flex align-center justify-center rounded-lg mb-3 mx-auto"
        >
          <v-icon color="blue darken-3">emergency</v-icon>
        </v-sheet>
        <h3 class="body-1 font-weight-bold mb-2 grey--text text--darken-3">
          Campos Obligatorios
        </h3>
        <p
          class="caption grey--text text--darken-1 text-justify px-2 lh-relaxed"
        >
          Se deben diligenciar todos los campos obligatorios de la pestaña
          <strong class="grey--text text--darken-4"> Empleados </strong>
          . El campo
          <strong class="grey--text text--darken-4">
            Fecha contrato hasta
          </strong>
          solo será obligatorio cuando el campo
          <strong class="grey--text text--darken-4"> Tipo de contrato </strong>
          sea distinto a {{ tipoContrato }}.
        </p>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'RecomendacionesImportacion',

  props: {
    tipoContrato: {
      type: String,
    },
  },
};
</script>
